import { STATUS_FILTER_OPTIONS } from '../lib/statusLabels';

interface SalesFilterBarProps {
  status: string;
  search: string;
  onStatusChange: (status: string) => void;
  onSearchChange: (search: string) => void;
  // Filtro só de exibição (nunca muda o que foi buscado do Worker) — some
  // da listagem qualquer venda que não gera comissão (ver
  // COMMISSION_GENERATING_STATUSES em lib/statusLabels.ts). Opcional pra
  // não obrigar toda tela que usa esta barra a ter o filtro.
  hideCanceled?: boolean;
  onHideCanceledChange?: (hideCanceled: boolean) => void;
}

export function SalesFilterBar({
  status,
  search,
  onStatusChange,
  onSearchChange,
  hideCanceled,
  onHideCanceledChange,
}: SalesFilterBarProps) {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
      <input
        type="search"
        placeholder="Buscar por transação ou produto…"
        className="input sm:max-w-xs"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
      />
      <select className="input sm:w-56" value={status} onChange={(event) => onStatusChange(event.target.value)}>
        {STATUS_FILTER_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {onHideCanceledChange ? (
        <label className="flex cursor-pointer select-none items-center gap-2 whitespace-nowrap text-sm text-[rgb(var(--text-muted))]">
          <input
            type="checkbox"
            className="h-4 w-4 accent-brand-500"
            checked={hideCanceled ?? false}
            onChange={(event) => onHideCanceledChange(event.target.checked)}
          />
          Ocultar canceladas
        </label>
      ) : null}
    </div>
  );
}
